var render = function render(){var _vm=this,_c=_vm._self._c;return (Boolean(_vm.selected))?_c('vs-col',{staticClass:"reset-alert-height"},[_c('vs-alert',{attrs:{"active":Boolean(_vm.selected),"title":_vm.selected.NOMECOMERCIAL,"color":"dark"}},[_c('p',{staticStyle:{"margin-top":"-10px"}},[_vm._v(" Atendimento (protocolo): "),_c('strong',[_vm._v(_vm._s(_vm.attendance))])])])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }